
import { useEffect, useState } from "react";
import { GTBRecords } from "../../helpers/interfaces";
import { Grid, MenuItem, Pagination, Stack, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../../layouts/themes";
import { getAllGTBRecords } from "../../apiServices/GTBRecordsApi";

interface Props {
    gtbRecordsToView: string

}
function SAPGTBRecords(props: Props) {

    const [generalTrialBlanceRecords, setGeneralTrialBlanceRecords] = useState<GTBRecords[]>([])
    const [filteredGeneralTrialBlanceRecords, setFilteredGeneralTrialBlanceRecords] = useState<GTBRecords[]>([])
    const [searchQuery,] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(40);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<GTBRecords[]>([])



    useEffect(() => {
        getAllGTBRecords(props.gtbRecordsToView).then(generalTrialBlanceRecords => setGeneralTrialBlanceRecords(generalTrialBlanceRecords))
    }, [props.gtbRecordsToView])

    useEffect(() => {
        setFilteredGeneralTrialBlanceRecords(generalTrialBlanceRecords.filter(e =>
            (searchQuery === "" || e.description.toLowerCase().includes(searchQuery.toLowerCase()) || e.glAccount.toLowerCase().includes(searchQuery.toLowerCase()))
        ));
        setCurrentPage(1);
    }, [searchQuery, generalTrialBlanceRecords])


    useEffect(() => {
        setNumOfPages(Math.ceil(filteredGeneralTrialBlanceRecords.length / recordsPerPage))
    }, [recordsPerPage, filteredGeneralTrialBlanceRecords])

    useEffect(() => {
        const lastIndex = currentPage * recordsPerPage;
        const firstIndex = lastIndex - recordsPerPage;
        setCurrentPageRecords(filteredGeneralTrialBlanceRecords.slice(firstIndex, lastIndex))
    }, [currentPage, recordsPerPage, filteredGeneralTrialBlanceRecords])


    return (

        <>

            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <TableContainer className="shadow-md sm:rounded-lg">
                    <Table className='summary overflow-x-auto table-auto' size="small" aria-label="a dense table"
                        aria-labelledby="tableTitle"
                    >
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell style={{ fontSize: '11px', }}> SN</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}> Co.Code</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>GL Account</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Description</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Amount</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Adjustment</StyledTableCell>
                                <StyledTableCell style={{ fontSize: '11px', }}>Final TB</StyledTableCell>
                                
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {currentPageRecords.map((item, index) => {
                                return <StyledTableRow key={index}>

                                    <StyledTableCell  >
                                        {index + 1 + ((currentPage - 1) * recordsPerPage)}
                                    </StyledTableCell>
                                    <StyledTableCell  >{item.coCode}</StyledTableCell>
                                    <StyledTableCell  >{item.glAccount}</StyledTableCell>
                                    <StyledTableCell  >{item.description}</StyledTableCell>
                                    <StyledTableCell  >{item.amount}</StyledTableCell>
                                    <StyledTableCell  >{item.adjustment}</StyledTableCell>
                                    <StyledTableCell  >{item.finalTB}</StyledTableCell>
                                    <StyledTableCell  >
                                    </StyledTableCell>

                                </StyledTableRow>
                            })}

                            {currentPageRecords.length === 0 &&
                                <tr>
                                    <StyledTableCell colSpan={13}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available....</p></StyledTableCell>
                                </tr>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <br />

            <nav>
                <div className=" flex flex-row ">
                    <div className=" flex items-start ">
                        <div className="px-6 py-2">Rows per page</div>&nbsp;
                        < Grid item xs={12} lg={3} >
                            <CustomTextField fullWidth id="fullWidth" select variant="outlined" size="small" name="RequestsNumbers" value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))} >

                                <MenuItem value="40">40</MenuItem >
                                <MenuItem value="55">55</MenuItem >
                                <MenuItem value="85">85</MenuItem >
                                <MenuItem value="125">125</MenuItem >
                                <MenuItem value="200">200</MenuItem >
                                <MenuItem value="255">255</MenuItem >
                                <MenuItem value="350">350</MenuItem >
                                <MenuItem value="500">500</MenuItem >


                            </CustomTextField>
                        </Grid>
                    </div>
                    <div style={{ flexGrow: 1 }} />
                    <Stack spacing={2}>
                        <Pagination color="secondary" count={numOfPages} siblingCount={1} boundaryCount={1}
                            onChange={(event, value) => setCurrentPage(value)} page={currentPage} size="small" classes={{ ul: "PaginationUl" }} />
                    </Stack>

                </div>
                <br />


            </nav>
        </>





    )
}
export default SAPGTBRecords;